<template>
    <div class="list">
        <manage-title>用户组</manage-title>
        <div class="content">
            <div class="top">
                <el-button
                    v-if="$store.state.isCheckEnd"
                    icon="el-icon-circle-plus"
                    type="success"
                    plain
                    size="medium"
                    @click="Add">
                    新增
                </el-button>
                <!-- <el-button
                    icon="el-icon-circle-plus"
                    type="primary"
                    plain
                    size="small"
                    @click="GotoImport"
                >
                    批量导入
                </el-button> -->
            </div>

            <div class="table">
                <el-table
                    ref="tableSort"
                    v-loading="listLoading"
                    :element-loading-text="loadingText"
                    :highlight-current-row="true"
                    :data="data"
                    row-key="ID"
                    :tree-props="{
                        children: 'children',
                        hasChildren: 'hasChildren'
                    }"
                >
                    <el-table-column
                        prop="Name"
                        label="名称"
                        align="left"
                        :tree-props="{
                            children: 'children',
                            hasChildren: 'hasChildren'
                        }"
                    ></el-table-column>

                    <el-table-column
                        prop="DescInfo"
                        label="备注"
                        align="left"
                    ></el-table-column>

                    <el-table-column
                        prop="CreateName"
                        label="创建者"
                        align="center"
                        width="150"
                    ></el-table-column>

                    <el-table-column
                        prop="CreateTime"
                        label="创建时间"
                        align="center"
                        width="180"
                    ></el-table-column>

                    <el-table-column
                        prop="RankNum"
                        label="排序"
                        align="center"
                        width="100"
                    ></el-table-column>

                    <el-table-column label="操作" width="250px" align="center">
                        <template #default="{ row }">
                            <el-button v-if="$store.state.isCheckEnd" size="mini" @click="Edit(row)"
                            >编辑
                            </el-button
                            >
                            <el-button
                                type="danger"
                                size="mini"
                                class="table-btn"
                                @click="Delete(row)"
                            >删除
                            </el-button
                            >
                            <el-button
                                type="primary"
                                plain
                                size="mini"
                                style="margin-top:5px"
                                @click="UserImport(row)"
                            >
                                用户导入
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!--（新增、编辑）弹框-->
            <div>
                <el-dialog
                    :destroy-on-close="true"
                    :close-on-click-modal="false"
                    width="550px"
                    :title="dialogTitle"
                    :visible.sync="dialogVisible"
                    custom-class="m-dialog"
                    :lock-scroll="false"
                    @close="CloseDialog"
                >
                    <el-form
                        ref="groupForm"
                        :rules="rules"
                        :model="groupForm"
                        size="medium"
                        label-width="120px"
                    >
                        <el-form-item label="名称" prop="Name">
                            <el-input
                                v-model="groupForm.Name"
                                class="dialog-text"
                            ></el-input>
                        </el-form-item>

                        <el-form-item label="父级用户组">
                            <el-cascader
                                v-model="groupForm.ParentId"
                                :options="data"
                                :props="{
                                    checkStrictly: true,
                                    value: 'ID',
                                    label: 'Name'
                                }"
                                clearable
                                class="dialog-text"
                                placeholder="请输入关键字检索..."
                            ></el-cascader>
                        </el-form-item>

                        <el-form-item label="备注">
                            <el-input
                                v-model="groupForm.DescInfo"
                                class="dialog-text"
                            ></el-input>
                        </el-form-item>

                        <el-form-item label="排序">
                            <el-input
                                v-model.number="groupForm.RankNum"
                                class="dialog-text"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="CloseDialog" size="small"
                        >取 消
                        </el-button
                        >
                        <el-button
                            type="primary"
                            @click="Save('groupForm')"
                            size="small"
                        >确 定
                        </el-button
                        >
                    </div>
                </el-dialog>
            </div>
            <!--（新增、编辑）弹框-->

            <!--用户导入弹框-->
            <div>
                <el-dialog
                    :destroy-on-close="true"
                    :close-on-click-modal="false"
                    width="750px"
                    title="用户导入"
                    :visible.sync="userImportVisible"
                    custom-class="m-dialog"
                    :lock-scroll="false"
                    @close="CloseDialog">
                    <el-form ref="" size="medium" label-width="150px">
                        <el-descriptions
                            title=""
                            :column="1"
                            style="padding:20px 70px 30px 70px;">
                            <el-descriptions-item
                                label="导入字段"
                                style="color:black"
                            >模板中的：用户名、密码、真实姓名为必填字段；其余字段（身份证、学号、电话、email、性别、简介等）根据实际情况自行填写；
                            </el-descriptions-item
                            >
                            <el-descriptions-item label="用  户  名"
                            >同一机构下的用户，用户名必须唯一，存在重复用户名将无法导入；
                            </el-descriptions-item
                            >
                            <el-descriptions-item label="模板下载"
                            ><a
                                :href="$store.state.protocol + '//fmh.cqvip.com/download/93ae86e933324f01a6d6a3fca12ec563.xls'"
                                download
                                style="text-decoration: none;color:red"
                            ><i
                                class="el-icon-download"
                                style="margin:0 5px"
                            ></i
                            >用户导入Excel模板</a
                            ></el-descriptions-item
                            >
                        </el-descriptions>

                        <el-form-item label="选择文件：">
                            <el-upload
                                class="upload-demo"
                                :action="$store.state.protocol + '//yixue.cqvip.com/Website/File/Upload'"
                                :limit="1"
                                :auto-upload="true"
                                :on-success="UploadSuccess"
                                accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                :before-upload="BeforeUpload">
                                <el-button size="small" type="primary">点击上传
                                </el-button>
                                <span
                                    slot="tip"
                                    class="el-upload__tip"
                                    style="margin-left:20px">
                                    只能上传Excel文件
                                </span>
                            </el-upload>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="ImportCloseDialog" size="small"
                        >取 消
                        </el-button
                        >
                        <el-button
                            type="primary"
                            @click="ImportUser"
                            size="small"
                        >确认导入
                        </el-button
                        >
                    </div>
                </el-dialog>
            </div>
            <!--用户导入弹框-->
        </div>
    </div>
</template>

<script>
import {
    GetOrganGroupInfo,
    SaveOrganGroup,
    DeleteOrganGroup,
    GroupImportUser
} from "@/api/category";
import ManageTitle from "@/components/manager/ManageTitle";
import { removeEmptyChildren } from "@/utils";
import { cloneDeep } from "lodash";

export default {
    components: { ManageTitle },
    data() {
        return {
            background: true,
            loadingText: "正在加载...",
            listLoading: false,
            data: [],
            // 弹框标题
            dialogTitle: "",
            dialogVisible: false,
            userImportVisible: false,
            // 用户组表单
            groupForm: {
                ID: 0,
                ParentId: [],
                Name: "",
                RankNum: null,
                DescInfo: ""
            },
            groupId: 0,
            fileUrl: "",
            rules: {
                Name: [
                    {
                        required: true,
                        message: "请填写用户组名称",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    created() {
        this.GetOrganGroupInfo();
    },
    methods: {
        // 获取机构用户组信息
        async GetOrganGroupInfo() {
            try {
                const { data } = await GetOrganGroupInfo();
                this.data = data.data;
                removeEmptyChildren(this.data, "children");
                // this.data.splice(0, 0, { KnowledgePointName: "无", id: "0" })
            } catch (err) {
                this.$toast("获取失败");
            }
        },
        // 打开新增弹框
        Add() {
            this.dialogTitle = "新增用户组";
            this.dialogVisible = true;
        },
        // 打开编辑弹框
        Edit(row) {
            this.dialogTitle = "编辑用户组";

            this.groupForm = {
                ID: row.ID,
                ParentId: row.ParentId,
                Name: row.Name,
                RankNum: row.RankNum,
                DescInfo: row.DescInfo
            };

            this.dialogVisible = true;
        },
        // 保存模块
        async Save(formName) {
            var result = false;
            this.$refs[formName].validate((valid) => {
                result = valid;
            });

            if (result) {
                try {
                    let form = cloneDeep(this.groupForm);
                    if (Array.isArray(form.ParentId)) {
                        form.ParentId = form.ParentId.pop();
                    }
                    const { data } = await SaveOrganGroup(form);

                    if (data.code === 100) {
                        this.$message({
                            message: "保存成功！",
                            type: "success"
                        });
                        this.GetOrganGroupInfo();
                        this.CloseDialog();
                    } else {
                        this.$message({
                            message: data.msg,
                            type: "error"
                        });
                    }
                } catch (err) {
                    console.error(err);
                    this.$message({
                        message: "服务器开小差了",
                        type: "error"
                    });
                }
            }
        },
        // 删除
        Delete(row) {
            try {
                this.$confirm("确认删除用户组：" + row.Name + "?", "提示", {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "warning",
                    lockScroll: false
                })
                    .then(() => {
                        this.DeleteGroup(row.ID);
                    })
                    .catch(() => {
                    });
            } catch (err) {
                this.$message({
                    message: "服务器开小差了！",
                    type: "error"
                });
            }
        },
        // 删除用户组
        async DeleteGroup(id) {
            try {
                const { data } = await DeleteOrganGroup({
                    Id: id
                });
                if (data.code === 100) {
                    this.$message({
                        message: data.msg,
                        type: "success"
                    });
                    this.GetOrganGroupInfo();
                } else {
                    this.$message({
                        message: data.msg,
                        type: "error"
                    });
                }
            } catch (err) {
                this.$message({
                    message: "删除发生异常！",
                    type: "error"
                });
            }
        },
        // 下拉框选择父级Id
        GetParentId(value) {
            this.groupForm.ParentId = value[value.length - 1];
        },
        // 用户导入前文件格式验证
        BeforeUpload(file) {
            console.log("type: ", file.type);
            const picLim = file.size / 1024 / 1024 < 5;

            if (!picLim) {
                this.$message.error("文件大小不能超过 5MB!");
                return false
            }
            return picLim;
        },
        // 上传成功
        UploadSuccess(response, file, fileList) {
            console.log(response, "response");
            if (response.code === 100) {
                this.fileUrl = response.data;
                this.$message.success(response.msg)
            } else {
                this.$message.error(response.msg);
            }
        },
        UserImport(row) {
            this.userImportVisible = true;
            this.groupId = row.ID;
        },
        // 用户导入
        async ImportUser() {
            if (!this.fileUrl) {
                this.$message.error("请选择文件!");
                return;
            }
            const { data } = await GroupImportUser({
                fileUrl: this.fileUrl,
                groupId: this.groupId
            });
            if (data.code === 100) {
                if (Object.isObj(data.data)) {
                    const { Success = 0, Fail = 0 } = data.data
                    this.$message.success(`导入成功${Success}条，导入失败${Fail}条`)
                } else {
                    this.$message.success(data.msg || "导入成功");
                }
                this.ImportCloseDialog();
            } else {
                this.$message.error(data.msg)
            }
        },
        // 跳转到批量导入
        GotoImport() {
            this.$router.push("/manage/user/importGroup");
        },
        // 关闭弹框
        CloseDialog() {
            this.dialogVisible = false;
            this.groupForm = {
                ID: 0,
                ParentId: null,
                Name: "",
                RankNum: null,
                DescInfo: ""
            };
        },
        // 关闭用户导入弹框
        ImportCloseDialog() {
            this.userImportVisible = false;
            this.groupId = 0;
            this.fileUrl = "";
        }
    }
};
</script>

<style lang="less" scoped>

.list {
    min-height: 700px;
    width: 100%;
    background: white;
    border-radius: 16px;
    margin: 0 auto;
    margin-bottom: 30px;
}

.tit {
    padding: 20px 20px 0px 20px;
    box-sizing: border-box;
    border-bottom: 1px solid #e5e8ec;

    .btns {
        width: 80px;
        height: 35px;
        box-sizing: border-box;
        margin: 0 25px 0 10px;
        cursor: pointer;

        .tab {
            width: 50px;
            height: 4px;
            background: #256cf4;
            border-radius: 2px;
        }
    }
}

.content {
    .top {
        padding: 20px;
    }

    .table {
        padding: 0 20px;

        .table-btn {
            cursor: pointer;
            margin-left: 5px;
        }
    }

    .dialog-text {
        width: 300px;
    }

    ::v-deep .el-upload-list__item {
        width: 80%;
    }
}
</style>
